import React from 'react';
import './ContactUs.css';
import { FaFacebook, FaInstagram, FaEnvelope } from 'react-icons/fa';

function ContactUs() {
    return (
        <div className="contact-social-container">
            <a
                href="https://www.facebook.com/fomeje"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-btn contact-facebook"
            >
                <FaFacebook /> Facebook
            </a>
            <a
                href="https://www.instagram.com/fomeje_morocco"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-btn contact-instagram"
            >
                <FaInstagram /> Instagram
            </a>
            {/* <a
                    href="https://www.linkedin.com/in/yourprofile"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link linkedin"
                >
                    <i className="fab fa-linkedin"></i> LinkedIn
                </a> */}
            {/* <a
                    href="https://twitter.com/yourprofile"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link twitter"
                >
                    <i className="fab fa-twitter"></i> Twitter
                </a> */}
            <a
                href="mailto:fomeje@gmail.com"
                className="contact-social-btn contact-email"
            >
                <FaEnvelope /> Email
            </a>
        </div>
    );
}

export default ContactUs;
